import { setAuthSessionItem, clearAuthSession } from "utils/authSession";
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import validator from "validator";
import { loadingAction } from "ReduxReducers/loadingReducer";
import { userlogin } from "ReduxReducers/loginReducers";
import AuthBrandPanel from "components/Auth/AuthBrandPanel";
import AuthField from "components/Auth/AuthField";
import { InlineFormMessage } from "components/InlineFeedback/InlineFeedback";
import eyeIcon from "assets/images/auth/eye-icon.svg";
import emailIcon from "assets/images/auth/email-icon.svg";
import { login } from "utils/authApi";
import { getSesstionDataByUserID, showResMsg } from "utils/generic";
import "styles/auth.css";

function SignIn() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [checkLogin, setCheckLogin] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [formError, setFormError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [values, setValues] = useState({
    emailAddress: "",
    userPassword: "",
    loginChecked: false,
  });

  useEffect(() => {
    dispatch(loadingAction(false));
    setAuthSessionItem("LOGIN_ROUTE", "/login");
    sessionStorage.removeItem("SIGN_DETAILS");
    if (localStorage.loginChecked === "true" && localStorage.emailAddress) {
      setValues((current) => ({
        ...current,
        emailAddress: localStorage.emailAddress,
        loginChecked: true,
      }));
      setCheckLogin(true);
    }
    async function restoreViewedUser() {
      if (!localStorage.viewUserID) return;
      const flag = await getSesstionDataByUserID(localStorage.viewUserID);
      setAuthSessionItem("LOGIN_DATETIME", JSON.stringify(new Date()));
      if (flag) window.location.href = "/dashboard";
      else {
        clearAuthSession();
        navigate("/");
      }
      localStorage.removeItem("viewUserID");
    }
    restoreViewedUser();
  }, []);

  const handleChange = (name) => (event) => {
    const value = event.target.value;
    setValues((current) => ({ ...current, [name]: value }));
    if (name === "emailAddress") setEmailError("");
    if (name === "userPassword") setPasswordError("");
  };

  const rememberMe = (event) => {
    const checked = event.target.checked;
    setCheckLogin(checked);
    setValues((current) => ({ ...current, loginChecked: checked }));
    localStorage.loginChecked = checked;
  };

  const submitLogin = (event) => {
    event.preventDefault();
    setFormError("");
    let invalid = false;
    const email = values.emailAddress.trim();
    const password = values.userPassword.trim();
    if (!email) {
      setEmailError("Email address can’t be blank");
      invalid = true;
    } else if (!validator.isEmail(email)) {
      setEmailError("Enter a valid email address");
      invalid = true;
    }
    if (!password) {
      setPasswordError("Password can’t be blank");
      invalid = true;
    } else if (password.length < 8 || password.length > 20) {
      setPasswordError("Password should be between 8 to 20 characters");
      invalid = true;
    }
    if (invalid) return;

    setIsSubmitting(true);
    localStorage.emailAddress = "";
    localStorage.userPassword = "";
    login(
      values,
      async (data) => {
        if (!data.Result_Status) {
          setIsSubmitting(false);
          dispatch(loadingAction(false));
          setFormError(data.Result_Message || "Invalid email or password");
          return;
        }
        if (data.Result_Output?.wizardStatusFlag === 0) {
          setIsSubmitting(false);
          navigate(`/wizard/${data.Result_Output.data._id}`);
          return;
        }
        const sessionReady = await getSesstionDataByUserID(
          data.Result_Output.data._id,
          dispatch
        );
        if (!sessionReady) {
          setIsSubmitting(false);
          clearAuthSession();
          navigate("/");
          return;
        }
        dispatch(
          userlogin(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")))
        );
        setAuthSessionItem("TOKEN", data.Result_Output.token);
        if (data.Result_Output.data.firstTimeUser === 1) {
          setIsSubmitting(false);
          setAuthSessionItem("RESET_PASSWORD", JSON.stringify("false"));
          navigate("/change");
          return;
        }
        if (values.loginChecked)
          localStorage.emailAddress = values.emailAddress;
        const role = JSON.parse(sessionStorage.getItem("ROLE"));
        if (!role) {
          setIsSubmitting(false);
          dispatch(loadingAction(false));
          setFormError("Role not found!");
          return;
        }
        setAuthSessionItem("USER_DETAILS", JSON.stringify(data.Result_Output.data));
        setAuthSessionItem("ROLE_NAME", role.roleName);
        if (role.roleName === "Super Admin") {
          setAuthSessionItem("LOGIN_ROUTE", "/dashboard-su");
          window.location.href = "/dashboard-su";
        } else if (role.roleName === "Warehouse Dashboard") {
          setAuthSessionItem("LOGIN_ROUTE", "/warehouseDashboard");
          window.location.href = "/warehouseDashboard";
        } else {
          setAuthSessionItem("LOGIN_ROUTE", "/dashboard");
          window.location.href = "/dashboard";
        }
      },
      dispatch
    );
  };

  return (
    <main className="auth-page auth-page--login">
      <AuthBrandPanel />
      <section className="auth-panel">
        <form className="auth-form" onSubmit={submitLogin} noValidate>
          <header className="auth-title">
            <h2>Welcome back</h2>
            <p>Sign in to continue</p>
          </header>
          {formError && (
            <InlineFormMessage
              message={formError}
              type="error"
              onClose={() => setFormError("")}
            />
          )}
          <div className="auth-inputs">
            <AuthField
              id="email-address"
              label="Email address"
              required
              error={emailError}
            >
              <input
                id="email-address"
                className={`auth-control${
                  emailError ? " auth-control--error" : ""
                }`}
                type="email"
                value={values.emailAddress}
                onChange={handleChange("emailAddress")}
                placeholder="name@company.com.au"
                maxLength={50}
                autoComplete="email"
              />
            </AuthField>
            <AuthField
              id="password"
              label="Password"
              required
              error={passwordError}
              action={
                <Link className="auth-field__action" to="/reset-pass">
                  Forgot password?
                </Link>
              }
            >
              <div className="auth-password">
                <input
                  id="password"
                  className={`auth-control${
                    passwordError ? " auth-control--error" : ""
                  }`}
                  type={showPassword ? "text" : "password"}
                  value={values.userPassword}
                  onChange={handleChange("userPassword")}
                  placeholder="Enter password"
                  maxLength={30}
                  autoComplete="current-password"
                />
                <button
                  className="auth-password__toggle"
                  type="button"
                  onClick={() => setShowPassword((shown) => !shown)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  <img src={eyeIcon} alt="" />
                </button>
              </div>
            </AuthField>
            <label className="auth-check">
              <input
                type="checkbox"
                checked={checkLogin}
                onChange={rememberMe}
              />
              <span>Keep me signed in</span>
            </label>
          </div>
          <div className="auth-actions">
            <button
              className={`auth-button auth-button--primary${
                isSubmitting ? " auth-button--loading" : ""
              }`}
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting && <span className="auth-button__spinner" />}
              <span>{isSubmitting ? "Signing in..." : "Sign in"}</span>
            </button>
            <div className="auth-divider" />
            <button
              className="auth-button auth-button--secondary"
              type="button"
              disabled={isSubmitting}
            >
              <img src={emailIcon} alt="" />
              Email me a sign-in link
            </button>
          </div>
          <p className="auth-signup">
            New to our platform?{" "}
            <Link className="auth-link" to="/authentication/sign-up">
              Start free on Silver
            </Link>
          </p>
        </form>
        <footer className="auth-legal">
          <a href="#privacy">Privacy</a>
          <span>·</span>
          <a href="#terms">Terms</a>
        </footer>
      </section>
    </main>
  );
}
export default SignIn;
